import { render, staticRenderFns } from "./PlantVarietyStatusForm.vue?vue&type=template&id=2ba9e6b0&"
import script from "./PlantVarietyStatusForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyStatusForm.vue?vue&type=style&index=0&id=2ba9e6b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports